<nav class="navbar navbar-expand-sm bg-light fixed-top" id="header">

    <ul class="nav flex-row">
        <img src="/assets/images/logo-medimail-patient.png" alt="MML Patient" width="200px"/>
    </ul>

    <ul class="nav flex-row nav-pills nav-tabs ml-5">
        <ng-container *ngFor="let lang of translate.getLangs()">
            <ul *ngIf="lang == 'en' || lang == 'fr'" [ngClass]="lang === translate.currentLang ? 'nav-link active' : 'nav-link'" (click)="changeLocale(lang)">
                {{ lang }}
                <span *ngIf="lang == 'en'" class="flag-icon flag-icon-us"></span>
                <span *ngIf="lang == 'fr'" class="flag-icon flag-icon-fr"></span>
            </ul>
        </ng-container>
    </ul>

    <ul class="navbar-nav ml-md-auto">
        <li *ngIf=" this.userService.isFullyAuthenticated() && this.router.url != '/otp' && this.router.url != '/error' && this.router.url != '/cgu'"
        class="nav-item">
            <a class="nav-link" [routerLink]="['/folders', this.defaultFolder]" title="{{ 'HEADER.MESSAGES' | translate }}">
                <i class="bi bi-envelope" style="font-size: 2em;"></i>
            </a>
        </li>

        <li *ngIf="this.userService.isFullyAuthenticated() && this.router.url != '/otp' && this.router.url != '/error' && this.router.url != '/cgu'"
        class="nav-item">
            <a class="nav-link" routerLink="/directory" title="{{ 'HEADER.DIRECTORY' | translate }}">
                <i class="bi bi-people" style="font-size: 2em;"></i>
            </a>
        </li>

        <li *ngIf="this.userService.isFullyAuthenticated() && this.router.url != '/otp' && this.router.url != '/error'
        && (this.userService.hasRealmRole('ROLE_MML_PATIENT_ADMIN') || this.userService.hasRealmRole('ROLE_MIPIH'))  && this.router.url != '/cgu'"
        class="nav-item">
            <a class="nav-link" routerLink="/superAdmin" title="{{ 'HEADER.SUPER-ADMIN' | translate }}">
                <i class="bi bi-gem" style="font-size: 2em;"></i>
            </a>
        </li>

        <li class="nav-item">
          <a class="nav-link" (click)="openHelp()" data-toggle="tooltip" data-placement="bottom" title="Assistance Medimail Patient">
            <i class="bi bi-info-circle" style="font-size: 2em;"></i>
          </a>
        </li>
    </ul>

    <span *ngIf="this.router.url != '/otp' && this.router.url != '/error' && this.router.url != '/cgu'
    && this.userService.isFullyAuthenticated()" class="sessionModal bg-primary" (click)="openUserInfo()">
        <b> {{ getInitial() }}</b>
    </span>

    <button *ngIf="this.userService.isAuthenticated()" type="button" class="btn btn-danger" (click)="logout()">
        <em class="bi bi-arrow-bar-left"></em>
    </button>

    <ul class="navbar-nav ml-md-auto" *ngIf="!this.userService.isAuthenticated() && !this.userService.currentUser.openMessage">
        <li class="nav-item">
            <button type="button" class="btn btn-link" (click)="login()">
                <mat-icon>login</mat-icon>
                {{ "HEADER.LOGIN" | translate }}
            </button>
        </li>
    </ul>
</nav>
